const DONE_CONTENT_STATUSES = new Set([
  'IMAGE_STATUS_COMPLETED',
  'IMAGE_STATUS_ERROR',
  'MEDIA_STATUS_COMPLETED',
  'MEDIA_STATUS_ERROR',
])

const PENDING_LIST_REFETCH_MS = 1000

interface ProcessedContent {
  image?: { status?: string }
  mediaItem?: { status?: string }
}

interface HistoryListSession {
  thumbnailUrl?: string
  isGenerating?: boolean
}

export function isFinishedContent(content: ProcessedContent | undefined) {
  const status = content?.mediaItem?.status ?? content?.image?.status
  if (!status) {
    return true
  }
  return DONE_CONTENT_STATUSES.has(status)
}

export function isHistoryThumbnailPending(session: HistoryListSession) {
  return Boolean(session.isGenerating) || !session.thumbnailUrl
}

export function historyListRefetchInterval(sessions: readonly HistoryListSession[]) {
  return sessions.some(isHistoryThumbnailPending) ? PENDING_LIST_REFETCH_MS : false
}

export function sessionPagesRefetchInterval(query: {
  state: { data?: { pages?: Array<{ sessions?: HistoryListSession[] }> } }
}) {
  return historyListRefetchInterval(
    query.state.data?.pages?.flatMap(page => page.sessions ?? []) ?? [],
  )
}
